
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([background='light']) .se-alpha-listing--mini-link{
    color:var(--gray-800);
  }

    :host([background='light']) .se-alpha-listing--mini-link.active{
      color:var(--brand-neutral-white);
      position:relative;
    }

    :host([background='light']) .se-alpha-listing--mini-link.active:after{
        content:'';
        position:absolute;
        width:1.25em;
        height:1.25em;
        background-color:var(--brand-primary-2);
        border-radius:50%;
        z-index:-1;
        left:-50%;
        top:0;
        right:-50%;
      }
  :host([background='light']) .se-alpha-listing--mini-span{
    color:var(--gray-400);
  }

:host([background='dark']) .se-alpha-listing--mini-link{
    color:var(--brand-neutral-white);
  }

:host([background='dark']) .se-alpha-listing--mini-link.active{
      color:var(--neutral-black);
      position:relative;
    }

:host([background='dark']) .se-alpha-listing--mini-link.active:after{
        content:'';
        position:absolute;
        width:1.25em;
        height:1.25em;
        background-color:var(--brand-neutral-white);
        border-radius:50%;
        z-index:-1;
        left:-50%;
        top:0;
        right:-50%;
      }

:host([background='dark']) .se-alpha-listing--mini-span{
    color:var(--gray-400);
  }

.se-alpha-listing--list-mini,
.se-alpha-listing--list,
ul ul{
  list-style-type:none;
  padding:0;
}

.se-alpha-listing--list-mini * > a, .se-alpha-listing--list * > a, ul ul * > a{
    text-decoration:none;
  }

.se-alpha-listing--list-mini{
  display:grid;
  grid-template-columns:1fr 1fr 1fr 1fr 1fr 0fr;
  grid-row-gap:1rem;
  padding:0 1rem;
}

@media (min-width: 640px){

.se-alpha-listing--list-mini{
    display:flex;
    width:100%;
    justify-content:space-between;
    column-gap:0;
    padding:0 2.5rem
}
  }

@media (min-width: 640px){

.se-alpha-listing--list-mini.search{
      padding:0 !important
  }
    }

.se-alpha-listing--mini-span,
.se-alpha-listing--mini-link{
  font-size:var(--fs-lg-mobile);
}

@media (min-width: 1024px){

.se-alpha-listing--mini-span,
.se-alpha-listing--mini-link{
    font-size:var(--fs-4xl)
}
  }

@media (min-width: 768px) and (max-width: 1023px){

.se-alpha-listing--mini-span,
.se-alpha-listing--mini-link{
    font-size:var(--fs-2xl)
}
  }

.se-alpha-listing--mini-span.search,
.se-alpha-listing--mini-link.search{
  font-size:var(--fs-lg-mobile);
}

@media (min-width: 768px){

.se-alpha-listing--mini-span.search,
.se-alpha-listing--mini-link.search{
    font-size:var(--fs-lg)
}
  }

.se-alpha-listing--card{
  width:100%;
  padding:2rem 1rem;
}

.se-alpha-listing--card.white{
    background-color:var(--brand-neutral-white);
  }

.se-alpha-listing--card.grayed{
    background-color:var(--brand-primary-4);
  }

.se-alpha-listing--card:focus{
    border:2px solid var(--brand-primary-1);
  }

@media (min-width: 768px){

.se-alpha-listing--card{
    align-items:center;
    column-gap:10%;
    display:flex;
    font-size:var(--fs-4xl)
}
  }

.se-alpha-listing--card-list{
  display:grid;
  width:100%;
  row-gap:1rem;
}

@media (min-width: 768px){

.se-alpha-listing--card-list{
    gap:2rem;
    grid-template-columns:1fr 1fr;
    padding:7.5rem 5rem
}
  }

.se-alpha-listing--item{
  display:flex;
  width:100%;
  max-width:440px;
}

.se-alpha-listing--link{
  font-weight:var(--fw-bold);
  font-family:var(--ff-dmsans);
  color:var(--brand-primary-2);
}

@media (min-width: 768px){

.se-alpha-listing--link{
    font-size:var(--fs-xl)
}
  }

.se-alpha-listing--letter{
  display:flex;
  font-size:var(--fs-super-mobile);
  color:var(--gray-600);
  font-family:var(--ff-rift);
  font-weight:Var(--fw-bold);
  line-height:normal;
  padding-bottom:1rem;
}

@media (min-width: 768px){

.se-alpha-listing--letter{
    font-size:var(--fs-super);
    padding:1.5rem
}
  }
`;